import { useTranslation } from 'react-i18next'
import type { OnboardingRecipientHistory } from '../../../api/onboardingTypes'

type NoticeKind = OnboardingRecipientHistory['classification']

/** Same wording and yellow treatment for one recipient or a group with the same history. */
export default function RecipientNotice({ histories, highlights = false }: {
  histories: OnboardingRecipientHistory[]
  highlights?: boolean
}) {
  const { t } = useTranslation('pages')
  const groups: { kind: NoticeKind; recipients: OnboardingRecipientHistory[] }[] = [
    { kind: 'blocked_partial', recipients: histories.filter((history) => history.classification === 'blocked_partial') },
    { kind: 'requires_acknowledgement', recipients: histories.filter((history) => history.classification === 'requires_acknowledgement') },
    { kind: 'new', recipients: histories.filter((history) => history.classification === 'new' && history.account_exists) },
  ]
  return <>
    {groups.filter(({ recipients }) => recipients.length > 0).map(({ kind, recipients }) => {
      const many = recipients.length > 1
      const message = kind === 'blocked_partial' ? t(`adminOnboarding.history.${many ? 'partialBlockedMultiple' : 'partialBlocked'}`)
        : kind === 'requires_acknowledgement' ? t(`adminOnboarding.history.${many ? 'completeMultiple' : 'completeNotice'}`)
        : t(`adminOnboarding.history.${many ? 'untrackedMultiple' : 'untracked'}`)
      return <div key={kind} className="rounded-lg border border-warning/40 bg-warning/10 p-3 text-sm text-warning"
        data-testid={kind === 'blocked_partial' ? highlights ? 'onboarding-highlight-warning' : 'onboarding-partial-block' : `onboarding-notice-${kind}`}>
        <div className="mb-1 flex flex-wrap gap-1">
          {recipients.map((history, index) => <span key={history.email}
            data-testid={highlights ? `onboarding-highlight-${history.email}` : undefined}>
            {history.email}{index < recipients.length - 1 ? ',' : ''}
          </span>)}
        </div>
        <p role={kind === 'blocked_partial' ? 'alert' : undefined}>{message}</p>
      </div>
    })}
  </>
}
